import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  banner: {
    backgroundColor: '#fdd6d6',
    border: '2px solid #834142',
    borderRadius: '8px',
    padding: '8px 16px',
  },
  bannerText: {
    color: '#563e3e',
    fontWeight: 800,
  },
}));
